module.exports = __webpack_public_path__ + "img/wave.169f4c6a.svg";